// Small toolbar shown on detail pages: period selector (1h / 24h / 7d / 30d)
// and a manual refresh button. Kept as its own component so the three detail
// pages share the same look and keyboard/a11y behaviour.

interface Props {
  windowHours: number;
  onWindowChange: (hours: number) => void;
  onRefresh: () => void;
  // When a detail page doesn't support a window (e.g. Service Bus real-time
  // counts), hide the selector and just show the refresh button.
  hideWindow?: boolean;
}

const OPTIONS: Array<{ value: number; label: string }> = [
  { value: 1, label: '1h' },
  { value: 24, label: '24h' },
  { value: 24 * 7, label: '7d' },
  { value: 24 * 30, label: '30d' },
];

export default function DetailControls({ windowHours, onWindowChange, onRefresh, hideWindow }: Props) {
  return (
    <div className="detail-controls">
      {!hideWindow && (
        <label className="detail-window">
          <span>Period</span>
          <select
            value={windowHours}
            onChange={(e) => onWindowChange(Number(e.target.value))}
            aria-label="Time window"
          >
            {OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      )}
      <button type="button" onClick={onRefresh} className="detail-refresh" aria-label="Refresh">
        ↻ Refresh
      </button>
    </div>
  );
}
